import React from 'react';
import { useTranslation } from 'react-i18next';
import './Page.css';
import './Zyciorys.css';
import biographyPhoto from '../assets/portrait/1. Chyba ulubione - 0 oryginał.png';

const Zyciorys = () => {
  const { t } = useTranslation();
  
  const timelineKeys = [
    { year: '1980', key: 'birth', type: 'career' },
    { year: '1988-1994', key: 'earlyEducation', type: 'education' },
    { year: '2004-2009', key: 'vocalStudies', type: 'education' },
    { year: '2008', key: 'debut', type: 'career' },
    { year: '2013', key: 'hamburgWorkshop', type: 'career' },
    { year: '2016', key: 'egyptConcert', type: 'achievement' },
    { year: '2018', key: 'competitionSuccess', type: 'achievement' },
    { year: '2008-2024', key: 'workshopImprovement', type: 'education' }
  ];

  const roleKeys = [
    { year: '2012-2015', key: 'annuncjata' },
    { year: '2013', key: 'livietta' },
    { year: '2011', key: 'wyrocznia' },
    { year: '2009', key: 'madameHertz' },
    { year: '2009', key: 'krolowaNocy' },
    { year: '2008', key: 'barbarinaSusanna' },
    { year: '2006', key: 'ersteKnabe' }
  ];

  const concertKeys = [
    { year: '2020', key: 'baroque2020' },
    { year: '2018', key: 'festival2018' },
    { year: '2017', key: 'festival2017' },
    { year: '2016', key: 'egypt2016' },
    { year: '2015', key: 'recital2015' },
    { year: '2013', key: 'recital2013' },
    { year: '2010', key: 'gala2010' },
    { year: '2009-2012', key: 'recitals2009' }
  ];

  const competitionKeys = [
    { year: '2018', key: 'spazioMusica' },
    { year: '2018', key: 'bellArte' },
    { year: '2016', key: 'emuse' }
  ];

  const getTimelineIcon = (type) => {
    switch (type) {
      case 'education':
        return '🎓';
      case 'achievement':
        return '🏆';
      case 'career':
        return '🎭';
      default:
        return '⭐';
    }
  };

  return (
    <div className="page">
      <div className="page-container">
        <div className="page-header">
          <h1>{t('biography.title')}</h1>
          <p className="page-subtitle">{t('biography.subtitle')}</p>
        </div>
        
        <div className="page-content">
          <div className="biography-intro">
            <div className="intro-text">
              <h2>{t('biography.aboutMe')}</h2>
              <p>
                {t('biography.aboutMeText2')}
              </p>
            </div>
            <div className="intro-image">
              <img 
                src={biographyPhoto}
                alt={t('biography.photoAlt')}
                className="biography-photo"
              />
            </div>
          </div>

          <div className="timeline-section">
            <h2>{t('biography.timeline')}</h2>
            <div className="timeline">
              {timelineKeys.map((item, index) => (
                <div key={index} className={`timeline-item ${item.type}`}>
                  <div className="timeline-marker">
                    <span className="timeline-icon">{getTimelineIcon(item.type)}</span>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-year">{item.year}</div>
                    <h3 className="timeline-title">{t(`biography.timelineItems.${item.key}.title`)}</h3>
                    <p className="timeline-description">{t(`biography.timelineItems.${item.key}.description`)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="achievements-section">
            <h2>{t('biography.rolesPerformed')}</h2>
            <div className="achievements-grid">
              {roleKeys.map((role, index) => (
                <div key={index} className="achievement-category">
                  <div className="timeline-year">{role.year}</div>
                  <h3>{t(`biography.roles.${role.key}.title`)}</h3>
                  <p><strong>{t(`biography.roles.${role.key}.opera`)}</strong></p>
                  <p className="timeline-description">{t(`biography.roles.${role.key}.venue`)}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="achievements-section">
            <h2>{t('biography.selectedConcerts')}</h2>
            <div className="achievements-grid">
              {concertKeys.map((concert, index) => (
                <div key={index} className="achievement-category">
                  <div className="timeline-year">{concert.year}</div>
                  <h3>{t(`biography.concerts.${concert.key}.title`)}</h3>
                  <p className="timeline-description">{t(`biography.concerts.${concert.key}.description`)}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="achievements-section">
            <h2>{t('biography.contests')}</h2>
            <div className="achievements-grid">
              {competitionKeys.map((competition, index) => (
                <div key={index} className="achievement-category">
                  <div className="timeline-year">{competition.year}</div>
                  <h3>{t(`biography.competitions.${competition.key}.title`)}</h3>
                  <p><strong>{t(`biography.competitions.${competition.key}.result`)}</strong></p>
                  <p className="timeline-description">{t(`biography.competitions.${competition.key}.location`)}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="achievements-section">
            <h2>{t('biography.education')}</h2>
            <div className="achievements-grid">
              <div className="achievement-category">
                <h3>{t('biography.formalEducation')}</h3>
                <ul>
                  <li>{t('biography.educationDetails.earlyEducation')}</li>
                  <li>{t('biography.educationDetails.academy')}</li>
                  <li>{t('biography.educationDetails.courses')}</li>
                </ul>
              </div>
              <div className="achievement-category">
                <h3>{t('biography.skillsQualifications')}</h3>
                <ul>
                  <li>{t('biography.educationDetails.teaching')}</li>
                  <li>{t('biography.educationDetails.languages')}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="philosophy-section">
            <h2>{t('biography.philosophy')}</h2>
            <blockquote>
              "{t('biography.philosophyText')}"
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Zyciorys;